import React, { Fragment } from 'react';

const OnlineCatalogSearchResult = ({ result, selectedItem }) => (
    <ul className="online-catalog-search-result">
        {result && result.map((item, index, array) => (
            <Fragment key={`${item.name}-${index}`}>
                <li className={`online-catalog-search-result__item ${selectedItem === index ? 'online-catalog-search-result__item--selected' : ''}`} >
                    <a className={`online-catalog-search-result__link ${item.url ? '' : 'online-catalog-search-result__link--disabled'}`} 
                        href={window.location.href.replace(window.location.search, '') + '?page=' + item.url}>
                        <div>{item.url} | {item.name}</div>
                    </a>
                </li>
            </Fragment>
        ))}
    </ul>
)

export default OnlineCatalogSearchResult;